import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DevicesService } from '../../services/devices/devices.service';
import { Device } from '../../models/device';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

@Component({
  selector: 'app-edit-device',
  templateUrl: './edit-device.component.html',
  styleUrls: ['./edit-device.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditDeviceComponent implements OnInit {
  @Input() device: Device;
  constructor(
    private devicesService: DevicesService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {}

  onDeviceConfigChanged() {
    this.devicesService.putDeviceConfig(this.device).subscribe(
      () => {
        this.messageService.add({
          severity: 'success',
          detail: this.translateService.instant(
            'main.add-devices.change-config-success'
          ),
          key: 'appMessage',
        });
        this.devicesService.devicesChanged.next(null);
      },
      () => {
        this.messageService.add({
          severity: 'error',
          detail: this.translateService.instant(
            'main.add-devices.change-config-error'
          ),
          key: 'appMessage',
        });
      }
    );
  }
}
